import { render, staticRenderFns } from "./MoneyData.vue?vue&type=template&id=581eb47a&scoped=true"
import script from "./MoneyData.vue?vue&type=script&lang=js"
export * from "./MoneyData.vue?vue&type=script&lang=js"
import style0 from "./MoneyData.vue?vue&type=style&index=0&id=581eb47a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581eb47a",
  null
  
)

export default component.exports